import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Suite.module.css'; // Import the CSS module
//import MainChartDisplay from './AIMarketDecoder/Visualization/MainChartDisplay';
import CombinedViewer from './AIMarketDecoder/Visualization/CombinedViewer';

const VisualizationSuite = () => {
  const [activeComponent, setActiveComponent] = useState(null);

  const showTopicInsightInput = () => {
    setActiveComponent('topic');
  };

  return (
    <div>
      {/* Main container */}
      <div className={styles.container}>
        {/* Heading */}
        <h3 className={styles.heading}>Dynamic Visualization</h3>

        {/* Buttons */}
        <div className={styles.buttonContainer}>
          <button 
            className={`${styles.button} ${activeComponent === 'topic' ? styles.active : ''}`} 
            onClick={showTopicInsightInput}
          >
            Get Data
          </button>
        </div>
      </div>

      {/* Active Section */}
      <div className={`${styles.activeSectionSmartSearch} ${activeComponent === 'topic' ? styles.active : ''}`}>
        {activeComponent === 'topic' && <CombinedViewer />}
      </div>

      {/* Back link */}
      <div className={styles.backLinkContainer}>
        <Link to="/">Back</Link>
      </div>
    </div>
  );
};

export default VisualizationSuite;